import { createReducer, on } from '@ngrx/store';
import { UiState } from '../ui.state';
import { SetExpandedProjectId } from '../actions/ui.action';

const initialUiState: UiState = {
  expandedProjectId: null,
};

export const uiActionReducer = createReducer(
  initialUiState,
  on(SetExpandedProjectId, (state, { item }): { expandedProjectId: string } => ({ ...state, expandedProjectId: item })),
);
